// extracted by mini-css-extract-plugin
export var container = "SeoLinks-module__container___D0FTF";
export var linkSection = "SeoLinks-module__linkSection___Hl1FL";